import { BaseAlertBanner } from '@components';
import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 24px;
    background-color: var(--colors-surface-primary, #fff);
    border: 1px solid var(--colors-border-primary, #e2e8f0);
    border-radius: 10px;
`;

export const ProgressBarWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    gap: 16px;
`;

export const Percentage = styled.div`
    font-family: 'Poppins', Helvetica, serif;
    font-weight: 600;
    font-size: 48px;
    line-height: 56px;
    color: var(--colors-text-body, #50566e);
    white-space: nowrap;
`;

export const BaseAlertBannerWrapper = styled(BaseAlertBanner)`
    width: 100%;
`;
